import axios from 'axios'

export default {
  fetchMyCollections (payload) {
      const { collection_id, token } = payload
      let url = '/api/collection'
      // Add query parameters if they exist
      if (collection_id && token) {
          url += `?collection_id=${collection_id}&token=${token}`
      }
        // Make the GET request to fetch collections
      return axios.get(url)
  },
  createNewCollection (payload) {
    return axios.post('/api/collection', payload)
  },
  fetchProductsInfo (payload) {
    return axios.post('/api/product/type-info', payload)
  },
  addToCollection (payload) {
    return axios.post('/api/collection/add-product', payload)
  },
  addBulkProductToCollection (payload) {
    return axios.post('/api/collection/add-products', payload)
  },
  removeFromCollection (payload) {
    return axios.post('/api/collection/remove-product', payload)
  },
  addProductsToCollection (payload) {
    return axios.post('/api/collection/add-products', payload)
  },
  addNote (payload) {
    return axios.post('/api/collection/add-note', payload)
  },
  deleteBulkCollection (payload) {
    return axios.delete('/api/collection/bulk-delete', payload)
  },
  updateCollectionReorder (payload) {
    return axios.patch('/api/collection/reorder-collection-update', payload)
  },
  fetchCatalogProducts (
    urlEndpoint,
    key,
    activeDraftOrderId,
    activeCollectionId
  ) {
    return axios.get(
      `${urlEndpoint}`,
        {params: { sort_by: key, active_order_id: activeDraftOrderId, active_collection_id: activeCollectionId}}
    )
  },
  updateCollection (payload, id) {
    return axios.patch(`/api/collection/${id}/update`, payload)
  },
  removeCollectionProducts (payload) {
    return axios.post('/api/collection/remove-products', payload)
  },
  fetchProductDetails (id, activeCollection, activeOrderId) {
    return axios.get(`/api/product/${id}/details?active_collection_id=${activeCollection}&active_order_id=${activeOrderId}`)
  },
  shareCollection (payload) {
    return axios.post('/api/collection/share', payload)
  },
  sendDigitalCatalog (payload) {
    return axios.post('/api/digital-catalog/send', payload)
  },
  addProductToCollectionByDesignNumber(payload) {
    // Add module type for the centralized API
    const data = {
      ...payload,
      module: 'collection'
    }
    return axios.post('/api/add-product-by-design-number', data)
  },
  fetchDesignMap() {
    return axios.get('/api/catalog/design-map')
  }
}
